import React from 'react';
import { useNavigate } from 'react-router-dom';
import './../../Style/QuizResults.css';

export const QuizResults = ({ score, questions, quizId }) => {
  const navigate = useNavigate();

  const totalPossibleScore = questions.length * 4;
  const percentage = Math.round((score * 100) / totalPossibleScore);

  // Dynamic feedback based on percentage
  let feedbackMessage = "Great Effort!";
  let badgeClass = "badge-good";
  if (percentage >= 80) {
    feedbackMessage = "Outstanding! Excellent Job 🏆";
    badgeClass = "badge-success";
  } else if (percentage >= 50) {
    feedbackMessage = "Good Job! Keep Practicing 👍";
    badgeClass = "badge-warning";
  } else {
    feedbackMessage = "Don't give up! Try again 💪";
    badgeClass = "badge-danger";
  }

  return (
    <div className="results-container">
      <div className="results-card">
        {/* Header Badge */}
        <div className={`result-badge ${badgeClass}`}>
          {feedbackMessage}
        </div>

        <h2>Mock Test Completed!</h2>
        <p className="results-subtitle">Here is a quick summary of your performance.</p>

        {/* Score Card Section */}
        <div className="score-summary-box">
          <div className="score-text-group">
            <span className="label">Your Final Score</span>
            <div className="score-main">
              {score} <span className="score-total">/ {totalPossibleScore}</span>
            </div>
          </div>
          <div className="percentage-pill">
            {percentage}%
          </div>
        </div>

        {/* Visual Progress Bar Section */}
        <div className="progress-container">
          <div className="progress-labels">
            <span>Accuracy Progress</span>
            <span className="progress-percentage-text">{percentage}%</span>
          </div>
          <div className="progress-bar-track">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
        </div>

        {/* Quick Stats Grid */}
        <div className="stats-grid">
          <div className="stat-card">
            <span className="stat-num">{questions.length}</span>
            <span className="stat-label">Total Questions</span>
          </div>
          <div className="stat-card">
            <span className="stat-num">{score} pts</span>
            <span className="stat-label">Points Earned</span>
          </div>
        </div>

        {/* Action Button */}  <br></br><br></br>
        <button className="details-btn" onClick={() => navigate(-2)}>
          Show Questions and Answers <span>➔</span>
        </button>
        <br></br><br></br><br></br>
      </div>
    </div>
  );
};